<template lang="html">
  <div>
    <v-form v-model="formularioValido" ref="form">
      <v-container>

        <!-- Mensagem informativa -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-alert
              class="alerta"
              color="#00796b"
              type="info"
              dense
              outlined
            >
              Adicione arquivos com os resultados do projeto na aba ARQUIVOS.
            </v-alert>
          </v-flex>
        </v-layout>

         <!-- Descrição dos resultados do projeto de pesquisa -->
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-textarea
              label="Descrição dos resultados do projeto de pesquisa*"
              v-model="projetoPesquisa.resultadosObtidos"
              counter="5000"
              :rows="3"
              :auto-grow="true"
              :rules="[...obrigatorio,...max5000caracteres]"
              hint="Deve ser inserida a referência das produções científica(s), tecnológica(s) e artística(s) e a formação de recursos humanos oriundas do projeto de pesquisa."
            >
            </v-textarea>
          </v-flex>
        </v-layout>

        <!-- Declaro, para devidos fins de direito, que as informações prestadas são verdadeiras e autênticas. Fico ciente de que a falsidade dessa declaração configura crime previsto no Código Penal Brasileiro, passível de penalidade. -->
        <v-layout row wrap justify-center>
          <v-flex xs12>
            <v-checkbox
              label="Declaro, para devidos fins de direito, que as informações prestadas são verdadeiras e autênticas. Fico ciente de que a falsidade dessa declaração configura crime previsto no Código Penal Brasileiro, passível de penalidade.*"
              v-model="projetoPesquisa.declaracaoResultadosObtidos"
              :rules="obrigatorio"
            >
            </v-checkbox>
          </v-flex>
        </v-layout>

        <br>

      </v-container>
    </v-form>

    <v-divider></v-divider>

    <v-card-actions>

      <!-- Botão "Cancelar" -->
      <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Salvar" -->
      <v-btn color="primary" :disabled="!formularioValido" @click="editarProjetoPesquisa()">Salvar</v-btn>

    </v-card-actions>

  </div>
</template>

<script>
  import projetos from '@/utils/projetos'
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      projetoPesquisa: {},
      obrigatorio: [v => !!v || 'Este campo é obrigatório'],
      max20caracteres: [v => v.length <= 20 || 'Este campo pode ter no máximo 20 caracteres'],
      max300caracteres: [v => v.length <= 300 || 'Este campo pode ter no máximo 300 caracteres'],
      max400caracteres: [v => v.length <= 400 || 'Este campo pode ter no máximo 400 caracteres'],
      max5000caracteres: [v => v.length <= 5000 || 'Este campo pode ter no máximo 5000 caracteres']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Edita um projeto de pesquisa.
      editarProjetoPesquisa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' })
        projetos.putProjetoPesquisa(this.idProjetoPesquisa, this.projetoPesquisa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaResultadosObtidos', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando Projeto de Pesquisa...' })
        })
      },

      // Redireciona para a página de visualização da aba "Resultados obtidos".
      cancelar: function () {
        this.$router.push({name: 'ProjetoPesquisaResultadosObtidos', params: {idProjetoPesquisa: this.idProjetoPesquisa}})
      }
    },
    mounted () {
      // Carrega o projeto de pesquisa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
      projetos.getProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.projetoPesquisa = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto de pesquisa...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }
  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>

<style scoped>

  .alerta {
    margin-top: 1.5em;
    margin-bottom: 2.0em;
  }

</style>



// WEBPACK FOOTER //
// editar-resultados-obtidos.vue?b0bab836